/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */

import { FormatF } from 'Shared/helpers';
import { isFuture } from 'Shared/utils/DateTime.utils';

function string_to_chart_js_y_axis_formatter(format) {
  if (format === 'integer') {
    return value => {
      if (value % 1 === 0) {
        return value;
      }
    };
  }
}

export function formatOptions(options, Chart) {
  // Stop event propegation when clicking on the legend items
  const legendOnClick = function legendOnClick(e, legendItem) {
    e.stopPropagation();

    if (this.chart.config.type === 'doughnut') {
      Chart.defaults.doughnut.legend.onClick.call(this, e, legendItem);
    } else {
      Chart.defaults.global.legend.onClick.call(this, e, legendItem);
    }
  };

  if (!options.legend) options.legend = {};
  options.legend.onClick = legendOnClick;

  let tooltips = {
    enabled: true,
    backgroundColor: 'white',
    bodyFontColor: '#343A40',
    bodyFontSize: 12,
    titleFontColor: '#343A40',
    bodyFontStyle: 'normal',
    footerFontSize: 12,
    footerFontColor: '#343A40',
    footerFontStyle: 'normal',
    xPadding: 8,
    yPadding: 8,
    borderColor: 'rgba(188, 190, 192, 1)',
    borderWidth: 1,
    displayColors: false,
    ...options.tooltips,
  };

  if (
    options.scales &&
    options.scales.yAxes &&
    options.scales.yAxes.length === 1 &&
    options.scales.yAxes[0].ticks &&
    options.scales.yAxes[0].ticks.callback &&
    typeof options.scales.yAxes[0].ticks.callback === 'string'
  ) {
    options.scales.yAxes[0].ticks.callback = string_to_chart_js_y_axis_formatter(
      options.scales.yAxes[0].ticks.callback
    );
  }

  tooltips = {
    ...tooltips,
    callbacks: {
      label: (tooltipItem, data) => {
        let format;
        if (
          options.tooltips &&
          options.tooltips.callbacks &&
          options.tooltips.callbacks.label &&
          typeof options.tooltips.callbacks.label === 'string'
        )
          format = options.tooltips.callbacks.label;
        else format = '';

        let label;

        if (data.datasets[tooltipItem.datasetIndex].data_labels) {
          label = data.datasets[tooltipItem.datasetIndex].data_labels[tooltipItem.index];
        } else if (data.datasets[tooltipItem.datasetIndex].label) {
          label = data.datasets[tooltipItem.datasetIndex].label || '';
          label += ': ';
          label += FormatF(format, tooltipItem.yLabel);
        } else if (data.labels) {
          label = data.labels[tooltipItem.index] || '';
          label += ': ';
          label += FormatF(format, data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
        }

        if (
          options.x_axis_values &&
          options.x_axis_values[tooltipItem.index] &&
          isFuture(options.x_axis_values[tooltipItem.index])
        ) {
          label += ' (Predicted)';
        }

        if (typeof options.onClick === 'function') return [label, 'Click to view details'];
        return [label];
      },
    },
  };

  return {
    ...options,
    tooltips,
    hiddenSlicesSeen: false,
  };
}

// TODO: Deprecate?
export function chartJSDataLabelOptions(data_labels, format) {
  let use_data_labels = false;
  let data_labels_font;
  if (data_labels) {
    if (data_labels.large_font) {
      data_labels_font = { weight: 'bold', size: 18 };
    }
    use_data_labels = true;
  }

  const display_options = use_data_labels ? context => context.chart.isDatasetVisible(context.datasetIndex) : false;

  return {
    color: 'grey',
    font: data_labels_font,
    formatter: (value, context) => {
      if (data_labels.only_use_first_x_axis_object && context.dataIndex > 0) return '';
      return FormatF(format, value);
    },
    display: display_options,
  };
}
